(function () {
  const Core = window.RB.Core;
  const { res, equip, empower, buff } = window.RB.CardLib;
  const { matchMightHere, renektonWatch } = window.RB.CardLib.ven;

  window.RB.CardScripts = window.RB.CardScripts || {};
  Object.assign(window.RB.CardScripts, {
    "Brutal Hunter": {
      abilities: [
        empower({ energy: 3, pips: 0, anyPower: 0, domains: null }),
      ],
      selfMightSpecs: [{ n: 2, cond: { k: "selfEmpowered" } }],
      selfKwSpecs: [{ name: "ganking", value: null, cond: { k: "selfEmpowered" } }],
    },

    "Onslaught": {
      play: [buff("$t1", 6)],
      targets: [{ bind: "t1", spec: { type: "unit" }, prompt: "Give +6 Might to..." }],
      flowCost: { energy: 4, pips: 0, anyPower: 0, domains: null },
    },

    "Fretful Feline": {
      triggers: [{
        on: "ready",
        self: true,
        label: "when I become ready: +2 Might this turn",
        program: [buff("source", 2)],
      }],
    },

    "Guttural Roar": {
      targets: [{
        bind: "t",
        spec: { type: "unit" },
        prompt: "Give +2 Might (+4 if it is Empowered) to which unit?",
      }],
      play: [{
        op: "if",
        cond: { k: "targetEmpowered", bind: "t" },
        then: [buff("$t", 4)],
        else: [buff("$t", 2)],
      }],
    },

    "Jagged Cutlass": {
      hostNoEnemyMove: true,
      abilities: [equip(res(0, 1, 0, ["body"]), { prompt: "Attach Jagged Cutlass to which unit you control?" })],
    },

    "Legion Marauder": {
      abilities: [
        empower(res(1, 0, 0, null)),
        empower(res(0, 1, 0, ["body"])),
      ],
      selfMightSpecs: [{ n: 1, cond: { k: "selfEmpowered" } }],
    },

    "Platewyrm Egg": {
      entersExhausted: true,
      abilities: [
        empower(res(1, 0, 0, null), { exhausts: true }),
        {
          label: "Add 1 Energy (2 while Empowered)",
          exhausts: true,
          reaction: true,
          isAdd: true,
          program: [{
            op: "if",
            cond: { k: "selfEmpowered" },
            then: [{ op: "addResources", res: { energy: 2 } }],
            else: [{ op: "addResources", res: { energy: 1 } }],
          }],
        },
      ],
    },

    "Repair Specialist": {
      selfKw: function (state, iid) {
        const Core = window.RB.Core;
        const o = state.objs[iid];
        if (!o) return [];
        let n = 0;
        for (const i of Core.boardObjs(state)) {
          if (state.objs[i].controller === o.controller && Core.isType(state, i, "gear")) n++;
        }
        return n ? [["assault", n]] : [];
      },
    },

    "Tools of Empire": {
      abilities: [
        empower(res(2, 0, 0, null)),
        {
          label: "Exhaust: give a unit +2 Might (+4 while Empowered) this turn",
          exhausts: true,
          targets: [{
            bind: "t",
            spec: { type: "unit" },
            prompt: "Give Might to which unit?",
          }],
          program: [{
            op: "if",
            cond: { k: "selfEmpowered" },
            then: [buff("$t", 4)],
            else: [buff("$t", 2)],
          }],
        },
      ],
    },

    "Baccai Witherclaw": {
      abilities: [empower(res(1, 0, 2, null))],
      selfMightSpecs: [{ n: 2, cond: { k: "selfEmpowered" } }],
      deathknell: [],
      triggers: [{
        on: "dies",
        condSpec: { k: "selfEmpowered" },
        label: "Deathknell while Empowered: channel 2 runes exhausted",
        program: [{ op: "channel", n: 2, exhausted: true }],
      }],
    },

    "Dame the Despoiler": {
      abilities: [empower(res(5, 1, 0, ["body"]))],
      triggers: [matchMightHere("attack"), matchMightHere("defend")],
    },

    "Rampage": {
      targets: [
        {
          bind: "f",
          spec: { type: "unit", friendly: true },
          prompt: "Choose a friendly unit",
        },
        {
          bind: "e",
          spec: { type: "unit", enemy: true },
          prompt: "Choose an enemy unit",
        },
      ],
      play: [{
        op: "if",
        cond: { k: "fromFacedown" },
        then: [{ op: "fight", a: "$f", b: "$e" }],
      }],
      addCosts: [{
        optional: true,
        cond: null,
        label: "Rampage",
        cost: res(0, 1, 0, ["body"]),
        then: [
          buff("$f", 2),
          { op: "fight", a: "$f", b: "$e" },
        ],
        otherwise: [{ op: "fight", a: "$f", b: "$e" }],
      }],
    },

    "Ambessa, The Wolf": {
      abilities: [empower(res(3, 1, 0, ["body"]))],
      selfMightSpecs: [{ n: 3, cond: { k: "selfEmpowered" } }],
      damageImmuneCond: {
        k: "and",
        conds: [{ k: "selfEmpowered" }, { k: "not", cond: { k: "inCombat" } }],
      },
    },

    "Gangplank, Naval": {
      abilities: [empower(res(0, 2, 0, ["body"]))],
      effectReplace: {
        kinds: ["stun", "minusMight", "toHand"],
        requiresEmpowered: true, grantMight: 3,
      },
    },

    "Hextech Disc": {
      abilities: [
        empower(res(0, 0, 0, null), { exhausts: true }),
        {
          cost: res(1, 0, 0, null),
          label: "Disempower this, exhaust: play a 3 Might Mech token to your base",
          exhausts: true,
          disempowerSelf: true,
          program: [{ op: "token", name: "Mech" }],
        },
      ],
    },

    "Jayce, Hammer in Hand": {
      triggers: [{
        on: "ready",
        self: true,
        label: "when I become ready: choose Assault 2, Deflect 2 or Ganking",
        program: [
          {
            op: "option",
            varKey: "j",
            prompt: "Give Jayce which keyword this turn?",
            options: ["Assault 2", "Deflect 2", "Ganking"],
          },
          {
            op: "if",
            cond: { k: "varEq", key: "j", value: 0 },
            then: [{ op: "grant", to: "source", keyword: "assault", kwValue: 2, dur: "turn" }],
          },
          {
            op: "if",
            cond: { k: "varEq", key: "j", value: 1 },
            then: [{ op: "grant", to: "source", keyword: "deflect", kwValue: 2, dur: "turn" }],
          },
          {
            op: "if",
            cond: { k: "varEq", key: "j", value: 2 },
            then: [{ op: "grant", to: "source", keyword: "ganking", kwValue: null, dur: "turn" }],
          },
        ],
      }],
    },

    "Cataclysmic Duel": {
      play: [
        {
          op: "choose",
          bind: "k0",
          spec: { type: "unit", friendly: true, ignoreUntargetable: true },
          prompt: "Choose a unit you control to keep",
        },
        {
          op: "choose",
          bind: "k1",
          byOpponent: true,
          spec: { type: "unit", enemy: true, ignoreUntargetable: true },
          prompt: "Choose a unit you control to keep",
        },
        {
          op: "kill",
          spec: {
            orSpecs: [
              { type: "unit", friendly: true, notBind: "k0", ignoreUntargetable: true },
              { type: "unit", enemy: true, notBind: "k1", ignoreUntargetable: true },
            ],
          },
        },
      ],
    },

    "Corrupted Dragon": {
      entersReadyCond: { k: "not", cond: { k: "scoreWithin", within: 3 } },
      triggers: [{
        on: "attack",
        self: true,
        label: "when I attack: send small enemy units here home",
        targets: [{
          bind: "m",
          spec: { type: "unit", enemy: true, here: true, maxMight: 5 },
          min: 0,
          max: 20,
          prompt: "Move any number of enemy units here with 5 Might or less to their base",
        }],
        program: [{ op: "move", to: "$m", dest: "base" }],
      }],
    },

    "Renekton, Brute": {
      abilities: [{
        cost: res(1, 0, 0, null),
        label: "Give me +1 Might this turn",
        program: [buff("source", 1)],
      }],
      selfKwSpecs: [
        { name: "deflect", value: 1, cond: { k: "selfEmpowered" } },
        { name: "ganking", value: null, cond: { k: "selfEmpowered" } },
      ],
      triggers: [
        renektonWatch("chainResolved", "Might 10 or more: empower me"),
        renektonWatch("attack", "Might 10 or more as an attacker: empower me"),
        renektonWatch("defend", "Might 10 or more as a defender: empower me"),
      ],
    },

    "Matriarch of War": {
      triggers: [
        {
          on: "empowered", label: "you empower something else: empower me",
          condSpec: { k: "and", conds: [{ k: "evYou" }, { k: "evOther" }] },
          program: [{ op: "empowerSource" }],
        },
      ],
      abilities: [
        {
          cost: { energy: 0, pips: 0, anyPower: 1, domains: null },
          label: "Disempower me: ready a unit",
          disempowerSelf: true,
          exhausts: true,
          targets: [
            {
              bind: "t", spec: { type: "unit", ready: false },
              prompt: "Ready which unit?",
            },
          ],
          program: [{ op: "ready", to: "$t" }],
        },
      ],
    },

    "Public Execution": {
      flowCost: { energy: 5, pips: 0, anyPower: 2, domains: null },
      targets: [
        { bind: "f", spec: { type: "unit", friendly: true }, prompt: "Choose a friendly unit" },
        {
          bind: "e", spec: { type: "unit", enemy: true, lessMightThanBind: "f" },
          prompt: "Kill which enemy unit with less Might than it?",
        },
      ],
      play: [{ op: "kill", to: "$e" }],
    },

    "Decree of Strength": {
      play: [
        {
          op: "revealHandPick", who: "opponent", bind: "d", domain: "mind",
          prompt: "They recycle which Mind card?",
        },
        { op: "recycleTargets", to: "$d" },
      ],
    },

    "Noxian Demolitionist": {
      triggers: [{
        on: "unitConquer", self: true, optional: true,
        label: "kill a gear with Energy cost no more than my Might",
        targets: [{
          bind: "t", spec: { type: "gear", maxEnergyAmt: "sourceMight" },
          prompt: "Kill which gear?",
        }],
        program: [{ op: "kill", to: "$t" }],
      }],
    },

    "Profiteer": {
      play: [{
        op: "may", prompt: "Disempower something you control to empower a legend, unit or gear?",
        then: [
          {
            op: "choose", bind: "d", spec: { friendly: true, empowered: true },
            prompt: "Disempower which of your permanents?",
          },
          { op: "disempower", to: "$d" },
          {
            op: "choose", bind: "e",
            spec: {
              orSpecs: [
                { type: "unit", notEmpowered: true },
                { type: "gear", notEmpowered: true },
                { zone: "legend", notEmpowered: true },
              ],
            },
            prompt: "Empower which legend, unit or gear?",
          },
          { op: "empower", to: "$e" },
        ],
      }],
    },

    "Wild Claw": {
      play: [
        {
          op: "lookTopTake", n: 5, optional: true, bind: "wc",
          prompt: "Banish a unit or gear from among them and play it for 5 Energy less (or none)",
          filter: { types: ["unit", "gear"] }, energyLess: 5,
        },
        {
          op: "delayed", on: "played", forEachBind: "wc", carry: ["wc"],
          label: "Wild Claw: Empower it",
          program: [{ op: "may", prompt: "Empower it?", then: [{ op: "empower", to: "$wc" }] }],
        },
      ],
    },
  });
})();
